import React, { useState } from 'react'
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import { useSelector } from 'react-redux'
import { FormControlLabel, Checkbox } from '@mui/material'
import './filterList.css'

export const FilterList = ({ filters, setFilters }) => {

    const { executiveList } = useSelector(state => state.general)
    const [anchorEl, setAnchorEl] = useState(null)
    // const [ejecutivo, setEjecutivo] = useState(executiveList)
    const ejecutivo = executiveList
    const [form, setForm] = useState({
        ...filters,
        por_aprobar: true
    })

    // const [validacion, setValidacion] = useState([
    //     { id: 'validado', nombre: 'Validado' },
    //     { id: 'por validar', nombre: 'Por validar' }
    // ])

    const validacion = [
        { id: 'validado', nombre: 'Validado' },
        { id: 'por validar', nombre: 'Por validar' }
    ]

    const handleSubmit = (e) => {
        e.preventDefault()

        if (!form.por_aprobar && !form.anulado) {
            setForm({
                ...form,
                por_aprobar: true
            })
        }

        setFilters(form)

    }

    const handleClose = () => {
        setAnchorEl(anchorEl);
    }

    const handleChangeChecked = (event) => {
        setForm({
            ...form,
            [event.target.name]: event.target.checked
        });
    }

    const handleChange = (event) => {
        setForm({
            ...form,
            [event.target.name]: event.target.value
        });
    }

    return (
        <div>
            <form onSubmit={handleSubmit} className="row g-2 formFilterList">
                <div className="col-12">
                    <Grid container>
                        <Grid item xs={12}>
                            <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>
                                <Grid item xs={12}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel id="demo-simple-select-label">Ejecutivo</InputLabel>
                                        <Select
                                            label="Ejecutivo"
                                            id="id_ejecutivo"
                                            name="id_ejecutivo"
                                            value={form?.id_ejecutivo || ''}
                                            onChange={handleChange}
                                            className='p-list-capitalize'
                                        >
                                            <MenuItem value='' key=''>Ninguno</MenuItem>
                                            {ejecutivo.map(item => (
                                                <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>
                                                    {item.nombre}{' '}{item.apellidos}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel id="demo-simple-select-label">Por Validación</InputLabel>
                                        <Select
                                            label="Validación"
                                            id="estado_validacion"
                                            name="estado_validacion"
                                            value={form?.estado_validacion || ''}
                                            onChange={handleChange}
                                            className='p-list-capitalize'
                                        >
                                            <MenuItem value='' key=''>Ninguno</MenuItem>
                                            {validacion.map(item => (
                                                <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>{item.nombre}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
                <div className="col-6 selectSpan">
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.por_aprobar}
                                onChange={handleChangeChecked}
                                name="por_aprobar"
                                color='secondary'
                            />
                        }
                        label="Por aprobar"
                    />
                </div>
                <div className="col-6 selectSpan">
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.anulado}
                                onChange={handleChangeChecked}
                                name="anulado"
                                color="secondary"
                            />
                        }
                        label="Anulados"
                    />
                </div>
                <div className="col-12 formFilterListButtons">
                    <button
                        type="button" className="btn btn-light buttonLimpiarFiltro"
                        onClick={handleClose}
                    >
                        Limpiar filtros
                    </button>
                    <button
                        type="button" className="btn btn-primary buttonBuscar"
                        onClick={handleSubmit}>
                        Buscar
                    </button>
                </div>
            </form>
        </div>
    )
}
